module.exports = __webpack_public_path__ + "static/media/line3.08654090.png";